import React from "react"
import {
  Box,
  Container,
  Text,
  Heading,
  Grid,
} from "@theme-ui/components"
import { getColor } from "@theme-ui/color"
import themeUiTheme from "../../gatsby-plugin-theme-ui"
import BaseContactForm from "../BaseContactForm"

const ContactForm = ({ title, subtitle, description, contactPage }) => {
  const dark = getColor(themeUiTheme, "dark")

  return (
    <Box
      sx={{
        py: [3, 3, 3, 3],
        backgroundColor: contactPage ? "light" : "primary",
      }}
    >
      <Container name="contactForm">
        <Box>
          <Grid columns={["1fr", "1fr", "1fr", ".4fr .6fr"]} gap={[1, 1, 1, 6]}>
            <Box>
              <Heading
                as="h2"
                variant="h1"
                sx={{
                  my: [4],
                  color: contactPage ? "dark" : "light",
                  fontSize: [6],
                  fontWeight: "body",
                  letterSpacing: "-.5px",
                  lineHeight: "1.12",
                  em: {
                    fontStyle: "normal",
                    color: contactPage ? "dark" : "light",
                  },
                }}
              >
                {title}
              </Heading>
              <Heading
                as="h3"
                variant="h3"
                sx={{
                  color: contactPage ? "dark" : "light",
                  fontWeight: 300,
                  my: [0, 4],
                }}
              >
                {subtitle}
              </Heading>

              <Text
                as="div"
                variant="sectionTitle"
                sx={{
                  my: [0, 4],
                  color: contactPage ? "dark" : "light",
                  fontSize: [4],
                  fontWeight: 300,
                  letterSpacing: "-.5px",
                  lineHeight: "1.12",
                  em: {
                    fontStyle: "normal",
                    color: contactPage ? "dark" : "light",
                  },
                }}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </Box>
            <Box sx={{ my: [4] }}>
              <BaseContactForm 
                variant={contactPage ? "dark" : "primary"}
                buttonText="INVIA RICHIESTA"
                showCompanyField={true}
                showCityField={true}
                showProvinceField={true}
                showMessageField={true}
              />
            </Box>
          </Grid>
        </Box>
      </Container>
    </Box>
  )
}

export default ContactForm
